import React from 'react'
import clsx from 'clsx'
import Image from 'next/image'

/* blocks */
import Button from '@/atoms/Button/Button'
import Link from 'next/link'

/* assets */
import { ReactComponent as PepperLogo } from 'public/assets/icons/WhitePepperLogo.svg'
import { ReactComponent as CircleRightIcon } from 'public/assets/solstice/icons/circle-ctrl-right.svg'

/* styling */
import styles from './_.module.css'

interface Props {
  className?: string
}

const SolsticeRegister: React.FC<Props> = ({ className }) => {
  return (
    <section className={clsx(className, 'relative ', styles.registerContainer)}>
      <div className="lg:col-start-1 lg:col-end-9">
        <h2 className="h1 | font-bold | mb-12">
          Join the ultimate global creative summit.
        </h2>

        <Link href="/solstice/register" legacyBehavior>
          <Button
            icon={<CircleRightIcon />}
            size="large"
            className="w-full | mb-16"
            style={{
              maxWidth: 376,
              boxShadow: '0px 8px 24px rgba(17, 0, 179, 0.15)'
            }}
          >
            Register for free
          </Button>
        </Link>

        <p className="text-paragraph-3">
          <strong>Brought to you by Pepper Content</strong>, Creative Solstice
          is a marquee design and marketing event to showcase the power of
          creative content in transforming businesses worldwide. The event is a
          gateway into expert insights, actionable takeaways, engaging
          conversations around design and marketing trends and the brilliant
          future of creative content marketing. It is the ideal setup to network
          with the most passionate and creative global content professionals.
        </p>
      </div>

      <div className="lg:col-start-9 lg:col-end-13 | pt-5 | flex flex-col justify-around items-center gap-8 | md:pt-8">
        <div className="">
          <Image
            src={'/assets/solstice/images/footer.png'}
            width={300}
            height={300}
            alt="3d elements"
          />
        </div>
        <div>
          <PepperLogo className="w-[169px] lg:w-[270px] |h-[32px] lg:h-[50px]" />
        </div>
      </div>
    </section>
  )
}

export default SolsticeRegister
